module.exports = __webpack_public_path__ + "static/media/epiglottis.2abdd78c.ogg";